/* ============================================================
   VERITAS PEPTIDES — theme.js
   veritaspeptides.com.au
   ============================================================ */
(function () {
  'use strict';

  /* ---- CURRENCY FORMATTING --------------------------------- */
  // Uses Shopify's money_format from the page if available
  function formatMoney(cents) {
    var fmt = window.Shopify && window.Shopify.money_format
      ? window.Shopify.money_format
      : '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return fmt.replace('{{amount}}', amount)
              .replace('{{amount_no_decimals}}', Math.round(cents / 100))
              .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  }

  function escHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ---- HEADER SCROLL --------------------------------------- */
  var header = document.getElementById('site-header');
  if (header) {
    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          // Threshold = announcement bar height (38px) so header darkens after bar scrolls past
          var barEl = document.getElementById('announcement-bar');
          var barH  = (barEl && barEl.style.display !== 'none') ? (barEl.offsetHeight || 38) : 0;
          header.classList.toggle('scrolled', window.scrollY > barH + 10);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---- CART DRAWER ----------------------------------------- */
  var cartDrawer  = document.getElementById('cart-drawer');
  var cartOverlay = document.querySelector('.cart-drawer-overlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  var cartToggle = document.getElementById('cart-toggle');
  var cartClose  = document.getElementById('cart-close');
  if (cartToggle)  cartToggle.addEventListener('click', openCart);
  if (cartClose)   cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ---- FETCH & RENDER CART --------------------------------- */
  async function fetchCart() {
    try {
      var res  = await fetch('/cart.js');
      if (!res.ok) throw new Error('Cart fetch failed: ' + res.status);
      var data = await res.json();
      renderCart(data);
    } catch(e) { console.warn('[VP] Cart fetch failed', e); }
  }

  function renderCart(cart) {
    // Update inline cart count in header button
    var inlineCount = document.getElementById('cart-count-display');
    if (inlineCount) {
      inlineCount.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    }
    var cartBtn = document.getElementById('cart-toggle');
    if (cartBtn) cartBtn.setAttribute('aria-label', 'Open cart, ' + cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : ''));

    var itemsEl    = document.getElementById('cart-items');
    var subtotalEl = document.getElementById('cart-subtotal');

    // Update all badge counts
    document.querySelectorAll('.cart-count-badge').forEach(function(el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML =
        '<div style="text-align:center;padding:56px 0;">' +
          '<svg width="36" height="36" fill="none" stroke="var(--ink-muted)" stroke-width="1.5" viewBox="0 0 24 24" style="margin:0 auto 14px;display:block;" aria-hidden="true">' +
            '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>' +
            '<line x1="3" y1="6" x2="21" y2="6"/>' +
            '<path d="M16 10a4 4 0 0 1-8 0"/>' +
          '</svg>' +
          '<p style="font-family:var(--font-mono);font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:var(--ink-muted);">Cart Empty</p>' +
          '<a href="/collections/all" style="font-family:var(--font-mono);font-size:10px;color:var(--cyan);letter-spacing:0.12em;text-transform:uppercase;text-decoration:none;margin-top:14px;display:inline-block;">Browse Compounds →</a>' +
        '</div>';
      if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      return;
    }

    itemsEl.innerHTML = cart.items.map(function(item) {
      var imgSrc  = (item.image) || (item.featured_image && item.featured_image.url) || '';
      var imgHtml = imgSrc
        ? '<img src="' + imgSrc + '" alt="' + escHtml(item.product_title) + '" style="width:100%;height:100%;object-fit:contain;padding:6px;" loading="lazy">'
        : '';
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== 'null')
        ? '<p style="font-family:var(--font-mono);font-size:10px;color:var(--ink-muted);letter-spacing:0.06em;margin-bottom:8px;text-transform:uppercase;">' + escHtml(item.variant_title) + '</p>'
        : '<div style="margin-bottom:8px;"></div>';

      return (
        '<div style="display:flex;gap:14px;padding:16px 0;border-bottom:1px solid var(--border);">' +
          '<div style="width:68px;height:68px;flex-shrink:0;background:var(--bg);border:1px solid var(--border);border-radius:var(--r-sm);overflow:hidden;display:flex;align-items:center;justify-content:center;">' +
            imgHtml +
          '</div>' +
          '<div style="flex:1;min-width:0;">' +
            '<p style="font-size:13px;font-weight:700;color:var(--ink);letter-spacing:-0.01em;margin-bottom:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + escHtml(item.product_title) + '</p>' +
            variantHtml +
            '<div style="display:flex;justify-content:space-between;align-items:center;">' +
              '<div style="display:flex;align-items:center;border:1px solid var(--border);border-radius:var(--r-xs);overflow:hidden;">' +
                '<button onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease quantity" style="width:28px;height:28px;background:var(--bg);border:none;color:var(--ink-soft);cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;transition:background 0.15s;" onmouseover="this.style.background=\'var(--border)\'" onmouseout="this.style.background=\'var(--bg)\'">−</button>' +
                '<span style="font-family:var(--font-mono);font-size:12px;font-weight:700;color:var(--ink);padding:0 10px;min-width:32px;text-align:center;" aria-label="Quantity: ' + item.quantity + '">' + item.quantity + '</span>' +
                '<button onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Increase quantity" style="width:28px;height:28px;background:var(--bg);border:none;color:var(--ink-soft);cursor:pointer;font-size:14px;display:flex;align-items:center;justify-content:center;transition:background 0.15s;" onmouseover="this.style.background=\'var(--border)\'" onmouseout="this.style.background=\'var(--bg)\'">+</button>' +
              '</div>' +
              '<span style="font-size:16px;font-weight:900;color:var(--ink);letter-spacing:-0.02em;">' + formatMoney(item.line_price) + '</span>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  }

  window.updateCartItem = async function(itemKey, qty) {
    try {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: Math.max(0, qty) })
      });
      if (!res.ok) { console.warn('[VP] Cart change HTTP error', res.status); }
      var data = await res.json();
      renderCart(data); // Shopify returns the full cart — render directly
    } catch(e) { console.warn('[VP] Cart change failed', e); fetchCart(); }
  };

  /* ---- AJAX ADD TO CART ------------------------------------ */
  document.addEventListener('submit', async function(e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();

    var btn  = form.querySelector('button[type="submit"]');
    var orig = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = 'ADDING…'; btn.disabled = true; }

    try {
      var res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      if (!res.ok) throw new Error('Cart add failed: ' + res.status);
      fetchCart(); // Refresh cart data immediately
      if (btn) {
        btn.innerHTML = '<svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> ADDED';
      }
      setTimeout(function() {
        if (btn) { btn.innerHTML = orig; btn.disabled = false; }
        openCart();
      }, 600);
    } catch(e) {
      console.warn('[VP] Add to cart failed', e);
      if (btn) { btn.innerHTML = 'ERROR — RETRY'; btn.disabled = false; }
    }
  });

  /* ---- SCROLL FADE-IN -------------------------------------- */
  function initFadeObserver() {
    var els = document.querySelectorAll('.fade-up');
    if (!els.length || !('IntersectionObserver' in window)) {
      // Fallback: show all immediately for old browsers
      els.forEach(function(el) { el.classList.add('visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function() { entry.target.classList.add('visible'); }, i * 60);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
    els.forEach(function(el) { io.observe(el); });
  }

  /* ---- SEARCH OVERLAY -------------------------------------- */
  var searchOverlay  = document.getElementById('search-overlay');
  var searchInput    = document.getElementById('search-input');
  var searchToggle   = document.getElementById('search-toggle');
  var searchCloseBtn = document.getElementById('search-close');

  function openSearch() {
    if (!searchOverlay) return;
    closeCart(); closeMobileNav();
    searchOverlay.classList.add('active');
    searchOverlay.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    if (searchInput) setTimeout(function() { searchInput.focus(); }, 80);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('active');
    searchOverlay.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  }

  if (searchToggle)  searchToggle.addEventListener('click', openSearch);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
  // Close search when clicking the backdrop (outside the search box)
  if (searchOverlay) {
    searchOverlay.addEventListener('click', function(e) {
      if (e.target === searchOverlay) closeSearch();
    });
  }

  var _searchTimer;
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      clearTimeout(_searchTimer);
      var q = this.value.trim();
      var resultsEl = document.getElementById('search-results');
      if (q.length < 2) { if (resultsEl) resultsEl.innerHTML = ''; return; }
      _searchTimer = setTimeout(function() { fetchSearchResults(q); }, 280);
    });
  }

  async function fetchSearchResults(query) {
    var resultsEl = document.getElementById('search-results');
    if (!resultsEl) return;
    try {
      var res  = await fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6');
      var data = await res.json();
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];

      if (!products.length) {
        resultsEl.innerHTML = '<p style="font-family:var(--font-mono);font-size:11px;letter-spacing:0.08em;color:var(--ink-muted);padding:16px 20px;text-transform:uppercase;">No results for "' + escHtml(query) + '"</p>';
        return;
      }

      resultsEl.innerHTML = products.map(function(p) {
        var imgHtml = p.featured_image
          ? '<img src="' + p.featured_image + '" alt="" width="48" height="48" style="width:100%;height:100%;object-fit:contain;padding:4px;" loading="lazy">'
          : '';
        return (
          '<a href="' + p.url + '" style="display:flex;gap:14px;padding:14px 20px;text-decoration:none;color:inherit;border-bottom:1px solid var(--border);align-items:center;transition:background 0.15s;" onmouseover="this.style.background=\'var(--bg)\'" onmouseout="this.style.background=\'\'">' +
            '<div style="width:48px;height:48px;flex-shrink:0;background:var(--bg);border:1px solid var(--border);border-radius:var(--r-sm);overflow:hidden;display:flex;align-items:center;justify-content:center;">' +
              imgHtml +
            '</div>' +
            '<div style="flex:1;min-width:0;">' +
              '<p style="font-size:14px;font-weight:700;color:var(--ink);letter-spacing:-0.01em;margin-bottom:2px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + escHtml(p.title) + '</p>' +
              '<p style="font-family:var(--font-mono);font-size:11px;color:var(--ink-muted);letter-spacing:0.04em;">' + (p.price || '') + '</p>' +
            '</div>' +
            '<svg width="14" height="14" fill="none" stroke="var(--ink-muted)" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>' +
          '</a>'
        );
      }).join('');
    } catch(e) { console.warn('[VP] Search failed', e); }
  }

  /* ---- MOBILE NAV ------------------------------------------ */
  var mobileNavBtn     = document.getElementById('mobile-nav-btn');
  var mobileNav        = document.getElementById('mobile-nav');
  var mobileNavOverlay = document.querySelector('.mobile-nav-overlay');

  function openMobileNav() {
    if (!mobileNav) return;
    closeCart(); closeSearch();
    mobileNav.classList.add('open');
    mobileNav.setAttribute('aria-hidden','false');
    if (mobileNavOverlay) mobileNavOverlay.classList.add('active');
    if (mobileNavBtn) mobileNavBtn.setAttribute('aria-expanded','true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    mobileNav.setAttribute('aria-hidden','true');
    if (mobileNavOverlay) mobileNavOverlay.classList.remove('active');
    if (mobileNavBtn) mobileNavBtn.setAttribute('aria-expanded','false');
    document.body.style.overflow = '';
  }

  if (mobileNavBtn)     mobileNavBtn.addEventListener('click', openMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  var mobileNavClose = document.getElementById('mobile-nav-close');
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);

  // Close mobile nav when any nav link is clicked
  document.querySelectorAll('.mobile-nav-links a').forEach(function(link) {
    link.addEventListener('click', closeMobileNav);
  });

  /* ---- GLOBAL ESC KEY -------------------------------------- */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') { closeCart(); closeSearch(); closeMobileNav(); }
  });

  /* ---- ANNOUNCEMENT BAR DISMISS ---------------------------- */
  var announceBar     = document.getElementById('announcement-bar');
  var announceDismiss = document.getElementById('announce-dismiss');
  if (announceDismiss && announceBar) {
    try {
      if (sessionStorage.getItem('vp_bar_dismissed') === '1') {
        announceBar.style.display = 'none';
        var hdr = document.getElementById('site-header');
        if (hdr) hdr.style.top = '0px';
        document.body.style.paddingTop = '0px';
      }
    } catch(e) {}
    announceDismiss.addEventListener('click', function() {
      // Animate bar out
      announceBar.style.transition = 'height 0.3s ease, opacity 0.2s ease';
      announceBar.style.height     = '0';
      announceBar.style.opacity    = '0';
      // Slide header up and reduce body padding simultaneously
      var hdr = document.getElementById('site-header');
      if (hdr) {
        hdr.style.transition = 'top 0.3s ease, background 0.5s, border-color 0.5s, backdrop-filter 0.5s';
        hdr.style.top = '0px';
      }
      document.body.style.transition = 'padding-top 0.3s ease';
      document.body.style.paddingTop = '0px';
      setTimeout(function() {
        announceBar.style.display = 'none';
        if (hdr) hdr.style.transition = '';
        document.body.style.transition = '';
      }, 320);
      try { sessionStorage.setItem('vp_bar_dismissed', '1'); } catch(e) {}
    });
  }


  /* ---- CATALOG ACCORDION ----------------------------------- */
  function initCatalogAccordion() {
    var triggers = document.querySelectorAll('.catalog-row-trigger');
    if (!triggers.length) return;

    triggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        var targetId = this.getAttribute('aria-controls');
        var detail   = document.getElementById(targetId);
        if (!detail) return;

        // Close any other open rows first (accordion behaviour)
        triggers.forEach(function(other) {
          if (other !== trigger && other.getAttribute('aria-expanded') === 'true') {
            var otherId = other.getAttribute('aria-controls');
            var otherDetail = document.getElementById(otherId);
            other.setAttribute('aria-expanded', 'false');
            if (otherDetail) otherDetail.hidden = true;
          }
        });

        // Toggle this row
        if (expanded) {
          this.setAttribute('aria-expanded', 'false');
          detail.hidden = true;
        } else {
          this.setAttribute('aria-expanded', 'true');
          detail.hidden = false;
          // Smooth scroll so the detail panel is visible
          setTimeout(function() {
            var rect = detail.getBoundingClientRect();
            var scrollBottom = rect.bottom + window.scrollY;
            var viewBottom   = window.scrollY + window.innerHeight;
            if (scrollBottom > viewBottom - 40) {
              detail.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          }, 50);
        }
      });
    });
  }

  /* ---- INIT ------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function() {
    initFadeObserver();
    fetchCart();
    initCatalogAccordion();
  });

})();
